export default {"src":"/_next/static/media/whats-app-logo-hover.454d19e1.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};